import { renderForCriticalMoment } from "../dashHelper";
import diagnostico from "./staticDashboards/diagnostico";
//import general from "./staticDashboards/general";

export default {
  title: 'Default Dashboard',
  description: 'Dashboard de perfil Default',
  backgroundClassName: (filters) => 'default',
  widgets: (filters: FiltersUI, filtersData: Record<string, any>) => [
    /*
      ...general.widgets(filters, filtersData)
        .map((wdg) => ({
          ...wdg,
          render: (filters: FiltersUI) => renderForCriticalMoment(filters, [29]),
        })),         */
        ...diagnostico.widgets(filters, filtersData)
        .map((wdg) => ({
          ...wdg,
          render: (filters: FiltersUI) => renderForCriticalMoment(filters, [29]),
        })),
    ],
    
} as DasboardConfig
